import { FC, useCallback } from 'react';

import clsx from 'clsx';

import { ToastProps } from './types';

import styles from './styles.module.scss';

import SuccessIcon from '@/assets/icons/done.svg?react';
import ErrorIcon from '@/assets/icons/error.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';

export const ToastNotification: FC<ToastProps> = ({ title, message, type }) => {
  const icons = useCallback(
    (type: ToastProps['type']) => {
      switch (type) {
        case 'success':
          return <SuccessIcon />;
        case 'error':
          return <ErrorIcon />;
        case 'warning':
          return <WarningIcon />;
      }
    },
    [type],
  );

  return (
    <div className={clsx(styles.toastContainer, styles[type])}>
      <div className={clsx(styles.icon, styles[`icon__${type}`])}>{icons(type)}</div>

      <div>
        <p className={styles.title}>{title}</p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};
